/*
 * See deploy_in_production.sh to see which env are set for the production web instance
 *
 * Select environment with:
 * - EXPO_PUBLIC_APP_ENV=production  (mobile / Expo Metro)
 * - REACT_APP_ENVIRONMENT=production (web / CRA)
 * - EAS_BUILD=true (set automatically by EAS Build)
 *
 * npm scripts:
 * - mobilenew: npm run start:production
 * - web: npm run start:production (or npm run dev:production)
 *
 * environment
 * what type of instance is running: local, dev, staging, or production
 * used by mobile and web builds
 *
 * apiBaseUrl
 * what is the backend API url
 * used by mobile and web builds
 *
 * vimeoBaseUrl
 * used for local testing only, to make vimeo videos load correctly
 * used by mobile builds only
 *
 * webAppBaseUrl
 * the frontend web app base url
 * used by mobile and web builds
 */
const productionEnv = {
  environment: 'production',
  apiBaseUrl: 'https://admin.breathingroom.me',
  webAppBaseUrl: 'https://app.breathingroom.me'
};

const useProduction =
  process.env.EAS_BUILD === 'true' ||
  process.env.EXPO_PUBLIC_APP_ENV === 'production' ||
  process.env.REACT_APP_ENVIRONMENT === 'production';

let env = useProduction
  ? productionEnv
  : {
      // for local web and mobile development:
      // in web production deploys, REACT_APP_* are set (see deploy_in_production.sh)
      environment: process.env.REACT_APP_ENVIRONMENT || 'local',
      apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://cinim-web.test',
      // vimeoBaseUrl: 'https://cinim.artisanapps.io',
      webAppBaseUrl:
        process.env.REACT_APP_APP_BASE_URL || 'http://app.cinim-web.test:3000'

      // optional hard-coded blocks for other mobile targets:
      // environment: 'dev',
      // apiBaseUrl: 'https://br-admin-dev.artisanapps.io',
      // webAppBaseUrl: 'https://br-app-dev.artisanapps.io',

      // environment: 'staging',
      // apiBaseUrl: 'https://cinim.artisanapps.io',
      // webAppBaseUrl: 'https://cinim-app.artisanapps.io',
    };

function envBackgroundColorStyle() {
  return env.environment === 'local'
    ? { backgroundColor: '#ffed4a' }
    : env.environment === 'dev'
      ? { backgroundColor: '#6cb2eb' }
      : env.environment === 'staging'
        ? { backgroundColor: '#38c172' }
        : {};
}

console.log('[env.js]', {
  env,
  EAS_BUILD: process.env.EAS_BUILD,
  EAS_BUILD_PROFILE: process.env.EAS_BUILD_PROFILE,
  EXPO_PUBLIC_APP_ENV: process.env.EXPO_PUBLIC_APP_ENV,
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_APP_BASE_URL: process.env.REACT_APP_APP_BASE_URL
});

export { env, envBackgroundColorStyle };
